import {
  MdHome,
  MdSupervisedUserCircle,
} from 'react-icons/md';
import { IoAnalytics } from "react-icons/io5";
import { LuWorkflow } from "react-icons/lu";
import { MdOutlineFeaturedVideo } from "react-icons/md";
import Default from '../views/Dashboard/Default';
import Analytics from '../views/Dashboard/Analytics';
import Customers from '../views/Dashboard/Customers';
import Flow from '../views/Dashboard/Flow';
import FeatureFlow from '../views/Dashboard/FeatureFlow';
import { IoSettingsOutline } from "react-icons/io5";
import Settings from '../views/Settings';

export const routes = [
  {
    name: "Pages & Events",
    layout: "/dashboard",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <Default />,
  },
  {
    name: "Customers",
    layout: "/dashboard",
    path: "customers",
    icon: <MdSupervisedUserCircle className="h-6 w-6" />,
    component:<Customers/>,
    secondary: true,
  },
  {
    name: "Analytics",
    layout: "/dashboard",
    path: "analytics",
    icon: <IoAnalytics className="h-6 w-6" />,
    component:<Analytics/>,
  },
  {
    name: "All Feature",
    layout: "/dashboard",
    path: "feature",
    icon: <MdOutlineFeaturedVideo className="h-6 w-6" />,
    component:<FeatureFlow/>,
  },
  {
    name: "Page Flow",
    layout: "/dashboard",
    path: "flow",
    icon: <LuWorkflow className="h-6 w-6" />,
    component:<Flow/>,
  },
  {
    name: "Settings",
    layout: "/dashboard",
    path: "settings",
    icon: <IoSettingsOutline className="h-6 w-6" />,
    component:<Settings/>,
  },
];
